import { Amplify } from "aws-amplify";
import { getCognitoAmplifyConfig } from "./cognitoConfig";

let configured = false;

/**
 * Configure Amplify Auth once for the SPA (Cognito user pool + Google OAuth).
 * Importing `signInWithRedirect` elsewhere also attaches Amplify’s OAuth callback listener.
 */
export function configureAmplifyAuth(): void {
  if (configured) return;
  const {
    userPoolId,
    userPoolClientId,
    domain,
    redirectSignIn,
    redirectSignOut,
  } = getCognitoAmplifyConfig();
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          oauth: {
            domain,
            scopes: ["openid", "email", "profile"],
            redirectSignIn,
            redirectSignOut,
            responseType: "code",
            providers: ["Google"],
          },
        },
      },
    },
  });
  configured = true;
}
